import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Modal, Tag } from "antd";
import React from "react";
import { Severty, ShowToast } from "../helper/toast";
import callApi from "../constants/API/CallApi";
const { confirm } = Modal;

const StatusChange = ({
  _id,
  isActive,
  callback,
  icon = <ExclamationCircleOutlined />,
  setLoading = () => {},
  setRefresh = () => {},
  trigger = true,
}) => {
  let color = isActive ? "green" : "red";

  const showConfirm = (recordId, status) => {
    confirm({
      icon,
      className: "tab_modal",
      content: "Are you sure you want to change the status ?",
      cancelButtonProps: {
        style: {
          backgroundColor: "#007AFF",
        },
      },
      onOk() {
        statusChange(recordId, status);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const statusChange = async (recordId, status) => {
    setLoading(true);
    callApi({
      callback,
      payload: [recordId, status],
      onSuccess: ({ message }) => {
        setRefresh(new Date().getTime());
        ShowToast(
          message || "Customer status change successfully",
          Severty.SUCCESS
        );
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };
  return (
    <div>
      <Tag
        onClick={() => trigger && showConfirm(_id, { isActive: !isActive })}
        className="cursor-pointer"
        color={color}
        key={isActive}
        style={{ cursor: "pointer" }}
      >
        {isActive ? "Active" : "Inactive"}
      </Tag>
    </div>
  );
};

export default StatusChange;
